import React, { useEffect, useState } from 'react';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

//Constants
import { actionsTable } from '../../../../constants/MaterialTable';

//Componentes
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';
import TipoDeFiscalizacaoStepper from './components/TipoDeFiscalizacaoStepper';

//API
import tipoDeFIscalizacao_api from "../../../../api/tipoDeFIscalizacao_api";

//Helpers
import { showMessage } from '../../../../helpers/message';

//Context
import { useAuth } from '../../../../context/auth';

export default function TipoDeFiscalizacao({ permissoes }) {
  //State para pegar lista dos tipos de fiscalizacao
  const [listTipoDeFiscalizacao, setListTipoDeFiscalizacao] = useState([]);

  //State para Criar
  const [tipoFiscalizacaoNovo, setTipoFiscalizacaoNovo] = useState(false);

  //State para edit
  const [tipoFiscalizacao_id, setTipoFiscalizacao_id] = useState(null);

  const { setLoading } = useAuth();

  //Variavel de controle de edição da tela
  const editavel = permissoes.filter(permissao => permissao.acao == "Editar").length > 0;

  //Cabeçalhos da lista de certificados
  const headers = [
    { value: "Identificação", objectValue: "identificacao", align: "left" },
    { value: "Status", objectValue: "status", align: "left" }
  ];

  const editar = (rowData) => {
    setTipoFiscalizacao_id(rowData.id);
  }

  const visualizar = (rowData) => {
    setTipoFiscalizacao_id(rowData.id);
  }

  //Variavel que guarda as ações da tabela
  const actions = [
    ...editavel
      ? [actionsTable.editar(editar)]
      : [actionsTable.visualizar(visualizar)]
  ];

  const loadTipoDeFiscalizacao = () => {
    setLoading(true);
    tipoDeFIscalizacao_api.getList()
      .then(response => {
        setListTipoDeFiscalizacao(response.data)
      })
      .catch(err => showMessage("Aviso", "Error ao buscar lista dos tipos de fiscalização", "error", null))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadTipoDeFiscalizacao();
  }, []);

  const handleVoltar = () => {
    setTipoFiscalizacao_id(null);
    setTipoFiscalizacaoNovo(false);
    loadTipoDeFiscalizacao();
  }

  if (tipoFiscalizacaoNovo || tipoFiscalizacao_id) {
    return <TipoDeFiscalizacaoStepper
      editavel={editavel}
      id={tipoFiscalizacao_id}
      handleVoltar={handleVoltar}
    />
  }

  return <>
    <div className='d-flex align-items-center justify-content-between mb-4'>
      <h4 className='text-secondary m-0'>Tipos de Fiscalização</h4>
      {editavel &&
        <Button
          color='success'
          onClick={() => setTipoFiscalizacaoNovo(true)
          }
        >
          <FontAwesomeIcon icon={faPlus} />  Adicionar
        </Button>
      }
    </div >
    <TabelaListagem
      actions={actions}
      title={"Lista de Tipos de Fiscalização"}
      headers={headers}
      items={listTipoDeFiscalizacao}
    />
  </>;
}